import { THEME_LIGHT, THEME_DARK, THEMES } from '@/constants/theme';

const themes = {
    ocean: { primary: { h: 194, s: '100%', l: '44%' }, secondary: { h: 210, s: '70%', l: '50%' } },
    forest: { primary: { h: 142, s: '71%', l: '35%' }, secondary: { h: 88, s: '50%', l: '40%' } },
    sunset: { primary: { h: 16, s: '90%', l: '55%' }, secondary: { h: 36, s: '95%', l: '50%' } },
    royal: { primary: { h: 248, s: '59%', l: '52%' }, secondary: { h: 280, s: '50%', l: '45%' } },
    crimson: { primary: { h: 348, s: '83%', l: '47%' }, secondary: { h: 15, s: '70%', l: '50%' } },
    slate: { primary: { h: 215, s: '16%', l: '47%' }, secondary: { h: 215, s: '25%', l: '60%' } }
};

export function useTheme() {
    function invertL(color) {
        const l = parseInt(color.l);
        return l > 65 ? '20%' : '100%';
    }

    function applyTheme(preset) {
        const theme = themes[preset];
        if (!theme) {
            clearTheme();
            return;
        }

        // Always remove and re-append to ensure it's after Bulma's CSS
        document.getElementById('org-theme')?.remove();
        const el = document.createElement('style');
        el.id = 'org-theme';
        document.head.appendChild(el);
        el.textContent = `:root {
            --bulma-primary-h: ${theme.primary.h};
            --bulma-primary-s: ${theme.primary.s};
            --bulma-primary-l: ${theme.primary.l};
            --bulma-primary-invert-l: ${invertL(theme.primary)};
            --bulma-link-h: ${theme.secondary.h};
            --bulma-link-s: ${theme.secondary.s};
            --bulma-link-l: ${theme.secondary.l};
            --bulma-link-invert-l: ${invertL(theme.secondary)};
        }`;
    }

    function clearTheme() {
        document.getElementById('org-theme')?.remove();
    }

    function applyDarkMode(preference) {
        if (preference === THEME_LIGHT || preference === THEME_DARK) {
            document.documentElement.setAttribute('data-theme', preference);
        } else {
            document.documentElement.removeAttribute('data-theme');
        }
        localStorage.setItem('theme', preference);
    }

    function cycleTheme(current) {
        return THEMES[(THEMES.indexOf(current) + 1) % THEMES.length];
    }

    return { themes, applyTheme, clearTheme, applyDarkMode, cycleTheme };
}
